const USER_REDIRECTION_TO_HOME = '/'
const SITE_NAME = 'MPF-Cloud'
const SITE_CUI = 'Controlled Unclassified Information (CUI)'
const ALL_SELECT_LABEL = 'All'
const NONE_LABEL = 'None'
const SELECT_LABEL = 'Select'

const ALL_SELECT_VALUE = -1
const ALL_SELECT_VALUE_STRING = ''

const CONCURRENCY_ERR_MSG = 'Another user performed an action. Click Ok to refresh the page.'

const SELECT_OPTION = {
  label: SELECT_LABEL,
  value: ALL_SELECT_VALUE,
}

const ALL_SELECT_OPTION = {
  label: ALL_SELECT_LABEL,
  value: ALL_SELECT_VALUE,
}
const NONE_SELECT_OPTION = {
  label: NONE_LABEL,
  value: ALL_SELECT_VALUE,
}
const NONE_SELECT_OPTION_STRING = {
  label: NONE_LABEL,
  value: ALL_SELECT_VALUE_STRING,
}

const ALL_SELECT_OPTION_STRING = {
  label: ALL_SELECT_LABEL,
  value: ALL_SELECT_VALUE_STRING,
}

const SELECT_OPTION_STRING = {
  label: 'Select',
  value: ALL_SELECT_VALUE_STRING,
}

const FileTypes = {
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  gif: 'image/gif',
  jpe: 'image/jpeg',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  msg: '',
  pdf: 'application/pdf',
  png: 'image/png',
  pps: 'application/vnd.ms-powerpoint',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  txt: 'text/plain',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}
const SUPPORTED_FILE_EXTENSIONS = ['doc', 'docx', 'xls', 'xlsx', 'msg', 'ppt', 'pptx']
const INQUIRY_STATUS = {
  ACTION_REQUIRED: { colorCode: '' },
  ALL: { colorCode: '' },
  CANCELED: { colorCode: '' },
  'CAREER_DEVELOPMENT-CSS': { colorCode: '25' },
  'CAREER_DEVELOPMENT-SECTION_CHIEF': { colorCode: '26' },
  'CAREER_DEVELOPMENT-SUPERVISOR': { colorCode: '27' },
  'CAREER_DEVELOPMENT-TECHNICIAN': { colorCode: '1' },
  CLOSED: { colorCode: '' },
  COMPLETED: { colorCode: '25' },
  'CUSTOMER_SUPPORT-CSS': { colorCode: '25' },
  'CUSTOMER_SUPPORT-SECTION_CHIEF': { colorCode: '26' },
  'CUSTOMER_SUPPORT-SUPERVISOR': { colorCode: '27' },
  'CUSTOMER_SUPPORT-TECHNICIAN': { colorCode: '1' },
  'FORCE_MANAGEMENT-CSS': { colorCode: '25' },
  'FORCE_MANAGEMENT-SECTION_CHIEF': { colorCode: '26' },
  'FORCE_MANAGEMENT-SUPERVISOR': { colorCode: '27' },
  'FORCE_MANAGEMENT-TECHNICIAN': { colorCode: '1' },
  IN_PROGRESS: { colorCode: '27' },
  'INSTALLATION_PERSONNEL_READINESS-CSS': { colorCode: '25' },
  'INSTALLATION_PERSONNEL_READINESS-SECTION_CHIEF': { colorCode: '26' },
  'INSTALLATION_PERSONNEL_READINESS-SUPERVISOR': { colorCode: '27' },
  'INSTALLATION_PERSONNEL_READINESS-TECHNICIAN': { colorCode: '1' },
  MPF_LEADERSHIP: { colorCode: 28 },
  NOT_STARTED: { colorCode: '23' },
  'PERSONNEL_SYSTEMS_MANAGEMENT-CSS': { colorCode: '25' },
  'PERSONNEL_SYSTEMS_MANAGEMENT-SECTION_CHIEF': { colorCode: '26' },
  'PERSONNEL_SYSTEMS_MANAGEMENT-SUPERVISOR': { colorCode: '27' },
  'PERSONNEL_SYSTEMS_MANAGEMENT-TECHNICIAN': { colorCode: '1' },
  REOPENED: { colorCode: '22' },
  RESOLVED: { colorCode: '24' },
  SAVED: { colorCode: '' },
  SUBMITTED: { colorCode: '23' },
}

const DUEOUT_STATUS = INQUIRY_STATUS

const MAX_LENGTHS = {
  EIGHT: '8',
  TEN_DIGITS: '10',
  TWO_HUNDRED_FIFTY: '250',
  TWO_HUNDRED_FIFTY_FIVE: '255',
}

const INQUIRY_AND_DUEOUT_FILTERS = {
  'Archived/Dueouts': [
    'Assigned Component',
    'Servicing MAJCOM',
    'Current Servicing Unit',
    'Servicing Organization',
    'Section',
    'Category',
    'Sub Category',
    'Submitted',
    'Archived Date',
  ],
  'Archived/Inquiries': [
    'Assigned Component',
    'Servicing MAJCOM',
    'Current Servicing Unit',
    'Servicing Organization',
    'Section',
    'Category',
    'Sub Category',
    'Submitted',
    'Archived Date',
  ],
  'Completed/Dueouts': [
    'Year',
    'Search',
    'Assigned Component',
    'Servicing MAJCOM',
    'Current Servicing Unit',
    'Servicing Organization',
    'Section',
    'Category',
    'Sub Category',
    'Priority',
    'Submitted',
    'Closed',
  ],
  'Completed/Inquiries': [
    'Year',
    'Search',
    'Assigned Component',
    'Servicing MAJCOM',
    'Current Servicing Unit',
    'Servicing Organization',
    'Section',
    'Category',
    'Sub Category',
    'Resolved/Closed Date',
    'Submitted',
  ],
  Dueouts: [
    'Year',
    'Search',
    'Assigned Component',
    'Servicing MAJCOM',
    'Current Servicing Unit',
    'Servicing Organization',
    'Section',
    'Category',
    'Sub Category',
    'RNLTD',
    'PDD',
    'DOS',
    'Due Date',
    'PRP',
    'Priority',
    'Submitted',
  ],
  Inquiries: [
    'Year',
    'Search',
    'Assigned Component',
    'Servicing MAJCOM',
    'Servicing Organization',
    'Current Servicing Unit',
    'Section',
    'Category',
    'Sub Category',
    'Assigned to Users',
    'Assigned Location',
    'Organization',
    'Priority',
    'Submitted',
  ],
  'MyInquiries/Dueouts': [
    'Year',
    'Search',
    'Assigned Component',
    'Servicing MAJCOM',
    'Servicing Organization',
    'Current Servicing Unit',
    'Section',
    'Category',
    'Sub Category',
    'RNLTD',
    'PDD',
    'DOS',
    'PRP',
    'Priority',
    'Due Date',
    'Submitted',
  ],
  'MyInquiries/Inquiries': [
    'Year',
    'Search',
    'Assigned Component',
    'Servicing MAJCOM',
    'Servicing Organization',
    'Current Servicing Unit',
    'Section',
    'Category',
    'Sub Category',
    'Submitted',
  ],
}
const INQUIRY_PAGES = ['Archived/Inquiries','Completed/Inquiries','MyInquiries/Inquiries', 'Inquiries' , ]
const DROP_DOWN_TITLES = {
  ArchivedDate: 'Archived Date',
  AssignedComponent: 'Assigned Component',
  AssignedLocation: 'Assigned Location',
  AssignedtoUsers: 'Assigned to Users',
  Category: 'Category',
  CurrentServicingUnit: 'Current Servicing Unit',
  Organization: 'Organization',
  Priority: 'Priority',
  Search: 'Search',
  Section: 'Section',
  ServicingMAJCOM: 'Servicing MAJCOM',
  ServicingOrganization: 'Servicing Organization',
  SubCategory: 'Sub Category',
  Submitted: 'Submitted',
  Year: 'Year',
}
const nodeStatusClasses = {
  Active: 'active',
  Inactive: 'inactive',
}
const ACTIONS = {
  CancelResponseRequired: 'CANCEL_RESPONSE_REQUIRED',
  Canceled: 'CANCELED',
  ChangedSection: 'CHANGE_SECTION',
  Closed: 'CLOSED',
  CustomerActionComplete: 'CUSTOMER_ACTION_COMPLETE',
  CustomerActionRequired: 'CUSTOMER_ACTION_REQUIRED',
  Elevated: 'ELEVATE',
  Other: 'ASSIGN_TO_OTHER',
  OtherSection: 'ASSIGN_TO_SECTION',
  OutsideActionComplete: 'OUTSIDE_ACTION_COMPLETE',
  PendingActionOutsideCP: 'PENDING_ACTION_OUTSIDE',
  Reopened: 'REOPENED',
  Resolved: 'RESOLVED',
  Responded: 'RESPOND',
  Self: 'ASSIGN_TO_SELF',
  Submitted: 'SUBMIT',
  TeamMemberAdded: 'TEAM_MEMBER_ADD',
  TeamMemberDeleted: 'TEAM_MEMBER_DELETE',
}

const DUEOUTS_ACTIONS = {
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  CANCEL: 'CANCEL',
  CLOSE: 'CLOSE',
  COMPLETE: 'COMPLETE',
  RESPOND: 'RESPOND',
  SAVE: 'SAVE',
  SUBMIT: 'SUBMIT',
}
const INQUIRY_ACTIONS = {
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  ASSIGN_TO_OTHER: 'ASSIGNED TO OTHER',
  ASSIGN_TO_SECTION: 'ASSIGNED TO OTHER SECTION',
  ASSIGN_TO_SELF: 'ASSIGNED SELF',
  CANCEL: 'CANCELED',
  CANCELED_RESPONSE_REQUESTED: 'CANCELED RESPONSE REQUESTED',
  CANCELED_RESPONSE_REQUIRED: 'CANCELED RESPONSE REQUIRED',
  CLOSED: 'CLOSED',
  COMPLETE: 'COMPLETE',
  CUSTOMER_ACTION_COMPLETE: 'CUSTOMER ACTION COMPLETE',
  CUSTOMER_ACTION_REQUIRED: 'CUSTOMER ACTION REQUIRED',
  ELEVATE: 'ELEVATED',
  OUTSIDE_ACTION_COMPLETE: 'ACTION OUTSIDE CP COMPLETED',
  PENDING_ACTION_OUTSIDE: 'PENDING ACTION OUTSIDE CP',
  REOPEN: 'REOPENED',
  RESOLVE: 'RESOLVED',
  RESPONDED: 'RESPONDED',
  SAVE: 'SAVE',
  SUBMIT: 'SUBMITTED',
  WAITING: 'WAITING',
}
const ACTION_BUTTON_POPUP_CONTROL = {
  AssignTo: 'AssignTo',
  CancelDueout: 'CancelDueout',
  CancelInquiry: 'CancelInquiry',
  CancelResponseRequired: 'CancelResponseRequired',
  Close: 'Close',
  CloseDueout: 'CloseDueout',
  Complete: 'Complete',
  CustomerAction: 'CustomerAction',
  CustomerActionComplete: 'CustomerActionComplete',
  Elevate: 'Elevate',
  OutsideActionComplete: 'OutsideActionComplete',
  PendingActionOutside: 'PendingActionOutside',
  Reopen: 'Reopen',
  Resolve: 'Resolve',
  Respond: 'Respond',
}
const DISCUSSION_LOG = {
  Assigned: 'Assigned To',
  CancelDueout: 'Canceled Dueout',
  CancelInquiry: 'Canceled',
  CancelResponseRequired: 'Canceled Response Required',
  Close: 'Closed',
  CloseDueout: 'Closed Dueout',
  Complete: 'Completed',
  CustomerAction: 'Customer Action Required',
  CustomerActionComplete: 'Customer Action Complete',
  Elevate: 'Elevated To', // To user group
  OutsideActionComplete: 'Action Outside CP Completed',
  PendingActionOutside: 'Pending Action Outside CP',
  Reopen: 'Reopened',
  Resolve: 'Resolved By', // By user role
  Respond: 'Responded', // user role Responded
}
const INQUIRY_ACTION_STRINGS = {
  AssignTo: 'AssignTo',
  Cancel: 'Cancel',
  CancelResponseRequired: 'CancelResponseRequired',
  Close: 'Close',
  Closed: 'Closed',
  CustomerActionComplete: 'CustomerActionComplete',
  CustomerActionRequired: 'CustomerActionRequired',
  Elevate: 'Elevate',
  OutsideActionComplete: 'PendingActionComplete',
  PendingActionOutside: 'PendingActionOutside',
  Reopen: 'Reopen',
  Resolve: 'Resolve',
  Respond: 'Respond',
}

const DUEOUT_ACTION_STRING = {
  AssignTo: 'AssignTo',
  Cancel: 'Cancel',
  Close: 'Close',
  Complete: 'Complete',
  Respond: 'Respond',
}
const INQUIRY_STATUS_IDS = {
  Canceled: 'CANCELED',
  CareerDevelopmentCSS: 'CAREER_DEVELOPMENT-CSS',
  CareerDevelopmentSectionChief: 'CAREER_DEVELOPMENT-SECTION_CHIEF',
  CareerDevelopmentSupervisor: 'CAREER_DEVELOPMENT-SUPERVISOR',
  CareerDevelopmentTechnician: 'CAREER_DEVELOPMENT-TECHNICIAN',
  Closed: 'CLOSED',
  CustomerSupportCSS: 'CUSTOMER_SUPPORT-CSS',
  CustomerSupportSectionChief: 'CUSTOMER_SUPPORT-SECTION_CHIEF',
  CustomerSupportSupervisor: 'CUSTOMER_SUPPORT-SUPERVISOR',
  CustomerSupportTechnician: 'CUSTOMER_SUPPORT-TECHNICIAN',
  ForceManagementCSS: 'FORCE_MANAGEMENT-CSS',
  ForceManagementSectionChief: 'FORCE_MANAGEMENT-SECTION_CHIEF',
  ForceManagementSupervisor: 'FORCE_MANAGEMENT-SUPERVISOR',
  ForceManagementTechnician: 'FORCE_MANAGEMENT-TECHNICIAN',
  InstallationPersonnelReadinessCSS: 'INSTALLATION_PERSONNEL_READINESS-CSS',
  InstallationPersonnelReadinessSectionChief: 'INSTALLATION_PERSONNEL_READINESS-SECTION_CHIEF',
  InstallationPersonnelReadinessSupervisor: 'INSTALLATION_PERSONNEL_READINESS-SUPERVISOR',
  InstallationPersonnelReadinessTechnician: 'INSTALLATION_PERSONNEL_READINESS-TECHNICIAN',
  MpfLeadership: 'MPF_LEADERSHIP',
  PersonnelSystemsManagementCSS: 'PERSONNEL_SYSTEMS_MANAGEMENT-CSS',
  PersonnelSystemsManagementSectionChief: 'PERSONNEL_SYSTEMS_MANAGEMENT-SECTION_CHIEF',
  PersonnelSystemsManagementSupervisor: 'PERSONNEL_SYSTEMS_MANAGEMENT-SUPERVISOR',
  PersonnelSystemsManagementTechnician: 'PERSONNEL_SYSTEMS_MANAGEMENT-TECHNICIAN',
  Reopened: 'REOPENED',
  Resolved: 'RESOLVED',
  Saved: 'SAVED',
  Submitted: 'SUBMITTED',
}

const MPF_ACTIVE_INQUIRY_KPI = [
  INQUIRY_STATUS_IDS.CareerDevelopmentCSS,
  INQUIRY_STATUS_IDS.CareerDevelopmentTechnician,
  INQUIRY_STATUS_IDS.CareerDevelopmentSupervisor,
  INQUIRY_STATUS_IDS.CareerDevelopmentSectionChief,
  INQUIRY_STATUS_IDS.CustomerSupportCSS,
  INQUIRY_STATUS_IDS.CustomerSupportTechnician,
  INQUIRY_STATUS_IDS.CustomerSupportSupervisor,
  INQUIRY_STATUS_IDS.CustomerSupportSectionChief,
  INQUIRY_STATUS_IDS.ForceManagementCSS,
  INQUIRY_STATUS_IDS.ForceManagementTechnician,
  INQUIRY_STATUS_IDS.ForceManagementSupervisor,
  INQUIRY_STATUS_IDS.ForceManagementSectionChief,
  INQUIRY_STATUS_IDS.InstallationPersonnelReadinessCSS,
  INQUIRY_STATUS_IDS.InstallationPersonnelReadinessTechnician,
  INQUIRY_STATUS_IDS.InstallationPersonnelReadinessSupervisor,
  INQUIRY_STATUS_IDS.InstallationPersonnelReadinessSectionChief,
  INQUIRY_STATUS_IDS.PersonnelSystemsManagementCSS,
  INQUIRY_STATUS_IDS.PersonnelSystemsManagementTechnician,
  INQUIRY_STATUS_IDS.PersonnelSystemsManagementSupervisor,
  INQUIRY_STATUS_IDS.PersonnelSystemsManagementSectionChief,
  INQUIRY_STATUS_IDS.MpfLeadership,
]
const USER_ROLES = {
  CPOwner: 'CP Owner',
  CSS: 'CSS',
  Customer: 'Customer',
  Leadership: 'Leadership',
  SectionChief: 'Section Chief',
  SiteAdmin: 'SiteAdmin',
  Supervisor: 'Supervisor',
  System: 'System',
  Technician: 'Technician',
}
const nonWaitingStatuses = ['SAVED', 'RESOLVED', 'CANCELED', 'CLOSED', 'REOPENED', 'SUBMITTED']
const waitingActions = [
  'RESPOND',
  'ELEVATE',
  'CUSTOMER_ACTION_COMPLETE',
  'CUSTOMER_ACTION_REQUIRED',
  'OUTSIDE_ACTION_COMPLETE',
  'PENDING_ACTION_OUTSIDE',
  'ASSIGN_TO_SELF',
  'ASSIGN_TO_OTHER',
  'ASSIGN_TO_SECTION',
  "CANCEL_RESPONSE_REQUIRED"
]
const ACTION_ROLES_HIERARCHY = [
  'SiteAdmin',
  'Leadership',
  'Section Chief',
  'Supervisor',
  'Technician',
  'CSS',
  'Customer',
]
const SERVICING_BY = {
  CSS: 'CSS',
  MPF: 'MPF',
}
const INQUIRY_INITIAL_FILTER = {
  CSSPASCODEFilter: ALL_SELECT_VALUE, // For CSS users
  assignedComponentCodeFilter: ALL_SELECT_VALUE, //
  assignedToLocationFilter: ALL_SELECT_VALUE_STRING, // Assigned To Location
  assignedToUsersFilter: ALL_SELECT_VALUE_STRING, // Assigned to Users
  categoryCodeFilter: ALL_SELECT_VALUE, // Category
  currentlyServicingByFilter : ALL_SELECT_VALUE_STRING, // current Servicing Unit
  isArchivedFilter: false,
  organizationFilter: ALL_SELECT_VALUE_STRING, // Organization
  priorityFilter: ALL_SELECT_VALUE_STRING, // Priority
  resolvedClosedDateFilter: ALL_SELECT_VALUE_STRING,
  savedFilter: false,
  searchFilter: ALL_SELECT_VALUE_STRING, // Search
  sectionCodeFilter: ALL_SELECT_VALUE, // Section
  servicingByFilter: ALL_SELECT_VALUE_STRING, // Servicing Unit
  servicingMAJCOMCodeFilter: ALL_SELECT_VALUE, // Servicing MAJCOM
  servicingOrganizationFilter: ALL_SELECT_VALUE_STRING, // Servicing Organization
  subCategoryCodeFilter: ALL_SELECT_VALUE, // Sub Category
  submittedFilter: ALL_SELECT_VALUE_STRING, // Submitted
  yearFilter: ALL_SELECT_VALUE, // Year
}
const DUEOUT_INITIAL_FILTER = {
  CSSPASCODEFilter: ALL_SELECT_VALUE, // For CSS users
  assignedComponentCodeFilter: ALL_SELECT_VALUE, //
  assignedToLocationFilter: ALL_SELECT_VALUE_STRING, // Assigned To Location
  assignedToUsersFilter: ALL_SELECT_VALUE_STRING, // Assigned to Users
  categoryCodeFilter: ALL_SELECT_VALUE, // Category
  closedFilter : ALL_SELECT_VALUE_STRING, // closed
  dueOutDOSFilter: ALL_SELECT_VALUE_STRING, // DOS
  dueOutDueDateFilter: ALL_SELECT_VALUE_STRING, // DueDate
  dueOutPDDFilter: ALL_SELECT_VALUE_STRING, // PDD
  dueOutPRPFilter: ALL_SELECT_VALUE_STRING, // Submitted
  dueOutRNLTDFilter: ALL_SELECT_VALUE_STRING, // RNLTD
  hasClosedAndCanceled:false,
  isArchivedFilter: false,
  isAscending: false,
  organizationFilter: ALL_SELECT_VALUE_STRING, // Organization
  priorityFilter: ALL_SELECT_VALUE_STRING, // Priority
  resolvedClosedDateFilter: ALL_SELECT_VALUE_STRING,
  searchFilter: ALL_SELECT_VALUE_STRING, // Search
  sectionCodeFilter: ALL_SELECT_VALUE, // Section
  servicingByFilter: ALL_SELECT_VALUE_STRING, // Current Servicing Unit
  servicingMAJCOMCodeFilter: ALL_SELECT_VALUE, // Servicing MAJCOM
  servicingOrganizationFilter: ALL_SELECT_VALUE_STRING, // Servicing Organization
  subCategoryCodeFilter: ALL_SELECT_VALUE, // Sub Category
  submittedFilter: ALL_SELECT_VALUE_STRING, // Submitted
  yearFilter: ALL_SELECT_VALUE, // Year
}
const DUEOUTS_STATUS = {
  CANCELED: 'CANCELED',
  CLOSED: 'CLOSED',
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS',
  NOT_STARTED: 'NOT_STARTED',
  SAVED: 'SAVED',
}
const ROLE_CODE = {
  CSS: 'CSS',
  Career_Development_Section_Chief: 'CD-Section Chief',
  Career_Development_Supervisor: 'CD-Supervisor',
  Career_Development_Technician: 'CD-Technician',
  Customer_Support_Section_Chief: 'CS-Section Chief',
  Customer_Support_Supervisor: 'CS-Supervisor',
  Customer_Support_Technician: 'CS-Technician',
  Force_Management_Section_Chief: 'FM-Section Chief',
  Force_Management_Supervisor: 'FM-Supervisor',
  Force_Management_Technician: 'FM-Technician',
  Installation_Personnel_Readiness_Section_Chief: 'IPR-Section Chief',
  Installation_Personnel_Readiness_Supervisor: 'IPR-Supervisor',
  Installation_Personnel_Readiness_Technician: 'IPR-Technician',
  Personnel_Systems_Management_Section_Chief: 'PSM-Section Chief',
  Personnel_Systems_Management_Supervisor: 'PSM-Supervisor',
  Personnel_Systems_Management_Technician: 'PSM-Technician',
}
// COMMENT_TYPES: Discussion comment types
const COMMENT_TYPES = {
  Customer: 'Customer',
  Internal: 'Internal',
}
const SEVERITY_OPTIONS = ['Low', 'Medium', 'High']
const FILE_EXTENSIONS = [
  '.xlsx',
  '.xls',
  '.doc',
  '.docx',
  '.ppt',
  '.pptx',
  '.txt',
  '.pdf',
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.msg',
]
//PII
export const FILE_ARRAY = 'FileArray'
export const LABELSTOSCAN = [
  'Question',
  'Title',
  'Subject',
  'Description',
  'Answer',
  'Comment',
  'Message',
]

export {
  ACTION_BUTTON_POPUP_CONTROL,
  ACTION_ROLES_HIERARCHY,
  ACTIONS,
  ALL_SELECT_LABEL,
  ALL_SELECT_OPTION,
  ALL_SELECT_OPTION_STRING,
  ALL_SELECT_VALUE,
  ALL_SELECT_VALUE_STRING,
  COMMENT_TYPES,
  CONCURRENCY_ERR_MSG,
  DISCUSSION_LOG,
  DROP_DOWN_TITLES,
  DUEOUT_ACTION_STRING,
  DUEOUT_INITIAL_FILTER,
  DUEOUT_STATUS,
  DUEOUTS_ACTIONS,
  DUEOUTS_STATUS,
  FILE_EXTENSIONS,
  FileTypes,
  INQUIRY_ACTION_STRINGS,
  INQUIRY_ACTIONS,
  INQUIRY_AND_DUEOUT_FILTERS,
  INQUIRY_INITIAL_FILTER,
  INQUIRY_PAGES,
  INQUIRY_STATUS,
  INQUIRY_STATUS_IDS,
  MAX_LENGTHS,
  MPF_ACTIVE_INQUIRY_KPI,
  NONE_LABEL,
  NONE_SELECT_OPTION,
  NONE_SELECT_OPTION_STRING,
  ROLE_CODE,
  SELECT_LABEL,
  SELECT_OPTION,
  SELECT_OPTION_STRING,
  SERVICING_BY,
  SEVERITY_OPTIONS,
  SITE_CUI,
  SITE_NAME,
  SUPPORTED_FILE_EXTENSIONS,
  USER_REDIRECTION_TO_HOME,
  USER_ROLES,
  nodeStatusClasses,
  nonWaitingStatuses,
  waitingActions,
}
